export const FETCH_LOCATION_LIST = "FETCH_LOCATION_LIST";
export const CREATE_LOCATION = "CREATE_LOCATION";
export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const FETCH_ALL_LOCATIONS_WITH_STATUS = "FETCH_ALL_LOCATIONS_WITH_STATUS";